import { API_BASE_URL } from 'constants/ApiConstant';

const dev = {
  ENV: 'dev',
  API_ENDPOINT_URL: API_BASE_URL,
};

const prod = {
  API_ENDPOINT_URL: API_BASE_URL,
  ENV: 'prod',
};

const test = {
  API_ENDPOINT_URL: '/api',
  ENV: 'test',
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case 'development':
      return dev;
    case 'production':
      return prod;
    case 'test':
      return test;
    default:
      break;
  }
};

export const env = getEnv();
export const getPath = (prodPath, devPath) =>
  env.ENV === 'prod' ? prodPath : devPath;
